/**
 * Custom image renderer for news view
 *
 * Props received from GDImageViewer:
 * - item:        { id, name, modifiedTime }
 * - openSrc:     (id, large?) => string URL
 * - onClick:     () => void
 * - classes:     slot-based className map
 * - styles:      slot-based inline-style map
 * - hover:       boolean
 * - attachClass: { [filename]: string }
 * - attachId:    { [filename]: string }
 */
export default function SingleNewsImage({
    item,
    openSrc,
    onClick,
    classes,
    styles,
    hover,
    attachClass = {},
    attachId = {},
    showDate,
}) {
    const { id, name, modifiedTime } = item;

    const formattedDate =
        showDate && modifiedTime
            ? new Date(modifiedTime).toLocaleDateString(undefined, {
                year: "numeric",
                month: "short",
                day: "numeric",
            })
            : "";

    return (
        <div>
            <div className="newsDateBadge">
            {formattedDate && (
                <h4 className="">{formattedDate}</h4>
            )}
            </div>
            <div className={classes.thumbWrapper} style={styles.thumbWrapper}>
                <img
                    src={openSrc(id)}
                    alt={name}
                    className={[
                        classes.image,
                        hover && "gd-hover",
                        attachClass[name],
                    ]
                        .filter(Boolean)
                        .join(" ")}
                    style={styles.image}
                    id={attachId[name]}
                    onClick={onClick}
                />
            </div>
        </div>
    );
}
